var render, staticRenderFns
import script from "./recipeNutrition.vue?vue&type=script&lang=js&"
export * from "./recipeNutrition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\actions-runner\\_work\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c06d7b3a', component.options)
    } else {
      api.reload('c06d7b3a', component.options)
    }
    
  }
}
component.options.__file = "PandoSites.Web/Shared/RecipeParts/Scripts/recipeNutrition.vue"
export default component.exports